// import "./student_new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import Select from "react-select";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { studentInputs } from "../../formSource";
// import { useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const PaperOptions = [
//   { value: "A+", label: "A+" },
//   { value: "A", label: "A" },
//   { value: "B", label: "B" },
//   { value: "C", label: "C" },
//   { value: "D", label: "D" },
// ];

// const CheckingOptions = [
//   { value: "VIII", label: "VIII" },
//   { value: "IX", label: "IX" },
//   { value: "X", label: "X" },
//   { value: "XI", label: "XI" },
// ];

// const isImage = (file) => file && file.type.startsWith("image/");
// const isPDF = (file) => file && file.type === "application/pdf";
// const StudentNew = ({ title }) => {
//   const [file, setFile] = useState("");
//   const [file_1, setFile_1] = useState("");
//   const [file_2, setFile_2] = useState("");
//   const [inputValues, setInputValues] = useState({});
//   const [notification, setNotification] = useState("");
//   const [isNotificationVisible, setIsNotificationVisible] = useState(false);
//   const [classoptions, setClassoptions] = useState([]);
//   const [batchoptions, setBatchoptions] = useState([]);
//   const [groupoptions, setGroupoptions] = useState([]);
//   const center_id = localStorage.getItem("center_id");
//   const navigate = useNavigate();
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const handlePaperSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       last_grade: selectedOption.value,
//     });
//   };

//   const handleCheckSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       last_class: selectedOption.value,
//     });
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setClassoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleBatchSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       batch_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     batch_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const batch_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/batch_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setBatchoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleGroupSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       group_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     group_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const group_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/group_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         const class_names = data.data[i].class_names;
//         const abbas = name + class_names;
//         console.log(data.data[i].class_names);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: abbas });
//       }
//       console.log(namelist);
//       setGroupoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleInputChange = (e) => {
//     console.log(e.target.name);
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log("inputValues", inputValues);
//     console.log("Files", e.target.files);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("image", file);
//     formData.append("name", inputValues.name);
//     formData.append("phone", inputValues.phone);
//     formData.append("father_name", inputValues.father_name);
//     formData.append("father_cnic", inputValues.father_cnic);
//     formData.append("father_phone", inputValues.father_phone);
//     formData.append("email", inputValues.email);
//     formData.append("address", inputValues.address);
//     formData.append("bform", file_1);
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("batch_id", inputValues.batch_id);
//     formData.append("class_id", inputValues.class_id);
//     formData.append("group_id", inputValues.group_id);
//     formData.append("description", inputValues.description);
//     formData.append("ref_name", inputValues.ref_name);
//     formData.append("bform_number", inputValues.bform_number);
//     formData.append("marksheet", file_2);
//     formData.append("ref_phone_no", inputValues.ref_phone_no);
//     formData.append("last_class", inputValues.last_class);
//     formData.append("last_grade", inputValues.last_grade);
//     formData.append("percentage", inputValues.percentage);
//     formData.append("status", inputValues.status || 1);
//     // formData.append("logo", file); // Append the file to FormData

//     try {
//       // Send formData to the server using an HTTP request with multipart/form-data
//       const response = await fetch(`${serverUrl}/add_student`, {
//         method: "POST",
//         body: formData, // Use formData here with multipart/form-data
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }

//         // Clear all input data and roles when error occurs
//         // setInputValues({});
//         // setSelectedUser([]);

//         // Force the component to rerender with the empty state
//         setTimeout(() => {}, 500); // Adding timeout to allow state change
//       } else {
//         toast.success("Student added successfully!");

//         // Clear form data after success
//         setInputValues({});
//         // setSelectedUser([]);

//         // Navigate to the users page after success
//         setTimeout(() => {
//           navigate("/student");
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="above">
//                 {/* Student Picture */}
//                 <div className="filePreview">
//                   {file && file.type && file.type.startsWith("image/") ? (
//                     <img
//                       src={URL.createObjectURL(file)}
//                       alt="Student Preview"
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src={file || "/images/upload_file.png"}
//                       alt="Default Student"
//                       className="itemImg"
//                     />
//                   )}
//                   {file && <p className="fileName">{file.name}</p>}
//                 </div>

//                 {/* Bform */}
//                 <div className="filePreview">
//                   {file_1 &&
//                   file_1.type &&
//                   file_1.type === "application/pdf" ? (
//                     <img
//                       src="/images/pdf_icon.png"
//                       alt="Bform PDF"
//                       className="itemImg"
//                     />
//                   ) : file_1 &&
//                     file_1.type &&
//                     file_1.type.startsWith("image/") ? (
//                     <img
//                       src={URL.createObjectURL(file_1)}
//                       alt="Bform Preview"
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src={file_1 || "/images/upload_file.png"}
//                       alt="Default Bform"
//                       className="itemImg"
//                     />
//                   )}
//                   {file_1 && <p className="fileName">{file_1.name}</p>}
//                 </div>

//                 {/* Marksheet */}
//                 <div className="filePreview">
//                   {file_2 &&
//                   file_2.type &&
//                   file_2.type === "application/pdf" ? (
//                     <img
//                       src="/images/pdf_icon.png"
//                       alt="Marksheet PDF"
//                       className="itemImg"
//                     />
//                   ) : file_2 &&
//                     file_2.type &&
//                     file_2.type.startsWith("image/") ? (
//                     <img
//                       src={URL.createObjectURL(file_2)}
//                       alt="Marksheet Preview"
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src={file_2 || "/images/upload_file.png"}
//                       alt="Default Marksheet"
//                       className="itemImg"
//                     />
//                   )}
//                   {file_2 && <p className="fileName">{file_2.name}</p>}
//                 </div>
//               </div>
//               <div className="below">
//                 <form onSubmit={handleSubmit}>
//                   <div className="formInput">
//                     <label htmlFor="file">
//                       Student Picture:{" "}
//                       <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="file"
//                       accept="image/*"
//                       onChange={(e) => setFile(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   <div className="formInput">
//                     <label htmlFor="Bformfile">
//                       Bform: <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="Bformfile"
//                       accept="image/*,.pdf"
//                       onChange={(e) => setFile_1(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   <div className="formInput">
//                     <label htmlFor="marksheetfile">
//                       Marksheet:{" "}
//                       <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="marksheetfile"
//                       accept="image/*,.pdf"
//                       onChange={(e) => setFile_2(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   {studentInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       {input.fieldName === "status" ? null : (
//                         <>
//                           <label>{input.label}</label>
//                           {input.fieldName === "class_id" ? (
//                             <Select
//                               options={classoptions}
//                               name={input.fieldName}
//                               onChange={handleClassSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "batch_id" ? (
//                             <Select
//                               options={batchoptions}
//                               name={input.fieldName}
//                               onChange={handleBatchSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "group_id" ? (
//                             <Select
//                               options={groupoptions}
//                               name={input.fieldName}
//                               onChange={handleGroupSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "last_class" ? (
//                             <Select
//                               options={CheckingOptions}
//                               name={input.fieldName}
//                               onChange={handleCheckSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "last_grade" ? (
//                             <Select
//                               options={PaperOptions}
//                               name={input.fieldName}
//                               onChange={handlePaperSelectChange}
//                               required
//                             />
//                           ) : (
//                             <input
//                               type={input.type}
//                               placeholder={input.placeholder}
//                               name={input.fieldName}
//                               onChange={handleInputChange}
//                               required={input.fieldName !== "status"}
//                             />
//                           )}
//                         </>
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//                 {isNotificationVisible && (
//                   <div className="notification">{notification}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}{" "}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default StudentNew;

import "./student_new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Select from "react-select";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState, useEffect, useCallback } from "react";
import { studentInputs } from "../../formSource";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FilePreviewContainer = styled("div")({
  position: "relative",
  width: "100%",
  height: 200,
  borderRadius: 12,
  border: "2px dashed #e0e0e0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#fafafa",
  marginBottom: 20,
  overflow: "hidden",
  transition: "all 0.3s ease",
  "&.drag-active": {
    borderColor: "#7451f8",
    backgroundColor: "rgba(116, 81, 248, 0.05)",
  },
});

const PreviewImage = styled("img")({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
});

const FileInfo = styled("div")({
  marginTop: 10,
  textAlign: "center",
  "& .fileName": {
    fontWeight: 500,
    color: "#333",
    fontSize: 14,
    marginTop: 8,
    wordBreak: "break-all",
    padding: "0 10px",
  },
  "& .fileSize": {
    color: "#757575",
    fontSize: 12,
  },
});

const RemoveButton = styled(Button)({
  position: "absolute",
  top: 8,
  right: 8,
  minWidth: 30,
  height: 30,
  borderRadius: "50%",
  padding: 0,
});

const PaperOptions = [
  { value: "A+", label: "A+" },
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
];

const CheckingOptions = [
  { value: "VIII", label: "VIII" },
  { value: "IX", label: "IX" },
  { value: "X", label: "X" },
  { value: "XI", label: "XI" },
];

const isImage = (file) => file && file.type.startsWith("image/");
const isPDF = (file) => file && file.type === "application/pdf";

const StudentNew = ({ title }) => {
  const [file, setFile] = useState(null); // Student picture
  const [filePreview, setFilePreview] = useState("");
  const [file_1, setFile_1] = useState(null); // Bform
  const [filePreview_1, setFilePreview_1] = useState("");
  const [file_2, setFile_2] = useState(null); // Marksheet
  const [filePreview_2, setFilePreview_2] = useState("");
  const [dragActive, setDragActive] = useState("");
  const [inputValues, setInputValues] = useState({});
  const [classoptions, setClassoptions] = useState([]);
  const [batchoptions, setBatchoptions] = useState([]);
  const [groupoptions, setGroupoptions] = useState([]);
  const center_id = localStorage.getItem("center_id");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 2000,
      onClose: () => (window.location.href = "/"),
    });
  };

  // File handling functions
  const handleDrag = useCallback((e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(type);
    } else if (e.type === "dragleave") {
      setDragActive("");
    }
  }, []);

  const handleDrop = useCallback((e, type) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive("");

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const selectedFile = e.dataTransfer.files[0];
      processFile(selectedFile, type);
    }
  }, []);

  const processFile = (selectedFile, type) => {
    if (!selectedFile) return;

    let fileTypeValid = false;
    let maxSize = 0;

    switch (type) {
      case "picture":
        fileTypeValid = isImage(selectedFile);
        maxSize = 2 * 1024 * 1024; // 2MB
        break;
      case "bform":
        fileTypeValid = isImage(selectedFile) || isPDF(selectedFile);
        maxSize = 5 * 1024 * 1024; // 5MB
        break;
      case "marksheet":
        fileTypeValid = isImage(selectedFile) || isPDF(selectedFile);
        maxSize = 5 * 1024 * 1024; // 5MB
        break;
    }

    if (!fileTypeValid) {
      toast.error(`Invalid file type for ${type}`);
      return;
    }

    if (selectedFile.size > maxSize) {
      toast.error(
        `File size exceeds ${maxSize / 1024 / 1024}MB limit for ${type}`
      );
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      if (type === "picture") {
        setFile(selectedFile);
        setFilePreview(e.target.result);
      } else if (type === "bform") {
        setFile_1(selectedFile);
        setFilePreview_1(e.target.result);
      } else if (type === "marksheet") {
        setFile_2(selectedFile);
        setFilePreview_2(e.target.result);
      }
    };

    if (isImage(selectedFile)) {
      reader.readAsDataURL(selectedFile);
    } else if (isPDF(selectedFile)) {
      if (type === "picture") {
        toast.error("Student picture must be an image file");
        return;
      }
      // For PDF, we don't need to read the content, just set the preview to PDF icon
      if (type === "bform") {
        setFile_1(selectedFile);
        setFilePreview_1("/images/pdf_icon.png");
      } else if (type === "marksheet") {
        setFile_2(selectedFile);
        setFilePreview_2("/images/pdf_icon.png");
      }
    }
  };

  const handleFileChange = (e, type) => {
    if (e.target.files && e.target.files[0]) {
      processFile(e.target.files[0], type);
    }
  };

  const handleRemoveFile = (type) => {
    if (type === "picture") {
      setFile(null);
      setFilePreview("");
    } else if (type === "bform") {
      setFile_1(null);
      setFilePreview_1("");
    } else if (type === "marksheet") {
      setFile_2(null);
      setFilePreview_2("");
    }
  };

  // Selection handlers
  const handlePaperSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      last_grade: selectedOption.value,
    });
  };

  const handleCheckSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      last_class: selectedOption.value,
    });
  };

  const handleClassSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      class_id: selectedOption.value,
    });
  };

  const handleBatchSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      batch_id: selectedOption.value,
    });
  };

  const handleGroupSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      group_id: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  // Fetch data functions
  useEffect(() => {
    class_name();
    batch_name();
    group_name();
  }, []);

  const class_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch classes");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setClassoptions(namelist);
    } catch (error) {
      console.error("Error fetching classes:", error);
      toast.error("Failed to load class data");
    }
  };

  const batch_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/batch_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch batches");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setBatchoptions(namelist);
    } catch (error) {
      console.error("Error fetching batches:", error);
      toast.error("Failed to load batch data");
    }
  };

  const group_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/group_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch groups");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: `${item.name} (${item.class_names})`,
      }));
      setGroupoptions(namelist);
    } catch (error) {
      console.error("Error fetching groups:", error);
      toast.error("Failed to load group data");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please upload a student picture");
      return;
    }

    if (!file_1) {
      toast.error("Please upload a Bform");
      return;
    }

    if (!file_2) {
      toast.error("Please upload a marksheet");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("name", inputValues.name || "");
    formData.append("common_name", inputValues.common_name || "");
    formData.append("phone", inputValues.phone || "");
    formData.append("father_name", inputValues.father_name || "");
    formData.append("father_cnic", inputValues.father_cnic || "");
    formData.append("father_phone", inputValues.father_phone || "");
    formData.append("email", inputValues.email || "");
    formData.append("address", inputValues.address || "");
    formData.append("bform", file_1);
    formData.append("center_id", center_id);
    formData.append("batch_id", inputValues.batch_id || "");
    formData.append("class_id", inputValues.class_id || "");
    formData.append("group_id", inputValues.group_id || "");
    formData.append("description", inputValues.description || "");
    formData.append("ref_name", inputValues.ref_name || "");
    formData.append("bform_number", inputValues.bform_number || "");
    formData.append("marksheet", file_2);
    formData.append("ref_phone_no", inputValues.ref_phone_no || "");
    formData.append("last_class", inputValues.last_class || "");
    formData.append("last_grade", inputValues.last_grade || "");
    formData.append("percentage", inputValues.percentage || "");
    formData.append("amount", inputValues.amount || "");
    formData.append("status", inputValues.status || 1);

    const toastId = toast.loading("Adding student...");

    try {
      const response = await fetch(`${serverUrl}/add_student`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        toast.update(toastId, {
          render: data.message || "Failed to add student",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });

        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        }
      } else {
        toast.update(toastId, {
          render: "Student added successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        // Reset form
        setFile(null);
        setFilePreview("");
        setFile_1(null);
        setFilePreview_1("");
        setFile_2(null);
        setFilePreview_2("");
        setInputValues({});

        setTimeout(() => {
          navigate("/student");
        }, 1500);
      }
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: "Error occurred while adding student",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      // Ensure no loading toast stays stuck
      toast.dismiss(toastId);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {/* File Upload Sections */}
                      <Grid item xs={12} md={4} className="formGridItem">
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          align="center"
                        >
                          Student Picture
                        </Typography>
                        <FilePreviewContainer
                          className={
                            dragActive === "picture" ? "drag-active" : ""
                          }
                          onDragEnter={(e) => handleDrag(e, "picture")}
                          onDragOver={(e) => handleDrag(e, "picture")}
                          onDragLeave={(e) => handleDrag(e, "picture")}
                          onDrop={(e) => handleDrop(e, "picture")}
                        >
                          {filePreview ? (
                            <>
                              <PreviewImage
                                src={filePreview}
                                alt="Student Preview"
                              />
                              {file && (
                                <>
                                  <FileInfo>
                                    <div className="fileName">{file.name}</div>
                                    <div className="fileSize">
                                      {(file.size / 1024).toFixed(1)} KB
                                    </div>
                                  </FileInfo>
                                  <RemoveButton
                                    variant="contained"
                                    color="error"
                                    onClick={() => handleRemoveFile("picture")}
                                  >
                                    ×
                                  </RemoveButton>
                                </>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                p: 2,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{
                                  fontSize: 48,
                                  color:
                                    dragActive === "picture"
                                      ? "#7451f8"
                                      : "#bdbdbd",
                                  mb: 1,
                                  transition: "color 0.3s",
                                }}
                              />
                              <Typography variant="body1" color="textSecondary">
                                {dragActive === "picture"
                                  ? "Drop your photo here"
                                  : "Drag & drop photo or"}
                              </Typography>
                              <Button
                                component="label"
                                variant="outlined"
                                startIcon={<DriveFolderUploadOutlinedIcon />}
                                sx={{ mt: 2 }}
                              >
                                Browse
                                <VisuallyHiddenInput
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleFileChange(e, "picture")
                                  }
                                  required
                                />
                              </Button>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                (Supports JPG, PNG up to 2MB)
                              </Typography>
                            </Box>
                          )}
                        </FilePreviewContainer>
                      </Grid>

                      <Grid item xs={12} md={4} className="formGridItem">
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          align="center"
                        >
                          Bform Document
                        </Typography>
                        <FilePreviewContainer
                          className={
                            dragActive === "bform" ? "drag-active" : ""
                          }
                          onDragEnter={(e) => handleDrag(e, "bform")}
                          onDragOver={(e) => handleDrag(e, "bform")}
                          onDragLeave={(e) => handleDrag(e, "bform")}
                          onDrop={(e) => handleDrop(e, "bform")}
                        >
                          {filePreview_1 ? (
                            <>
                              {isPDF(file_1) ? (
                                <PreviewImage
                                  src="/images/pdf_icon.png"
                                  alt="Bform PDF"
                                />
                              ) : (
                                <PreviewImage
                                  src={filePreview_1}
                                  alt="Bform Preview"
                                />
                              )}
                              {file_1 && (
                                <>
                                  <FileInfo>
                                    <div className="fileName">
                                      {file_1.name}
                                    </div>
                                    <div className="fileSize">
                                      {(file_1.size / 1024).toFixed(1)} KB
                                    </div>
                                  </FileInfo>
                                  <RemoveButton
                                    variant="contained"
                                    color="error"
                                    onClick={() => handleRemoveFile("bform")}
                                  >
                                    ×
                                  </RemoveButton>
                                </>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                p: 2,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{
                                  fontSize: 48,
                                  color:
                                    dragActive === "bform"
                                      ? "#7451f8"
                                      : "#bdbdbd",
                                  mb: 1,
                                  transition: "color 0.3s",
                                }}
                              />
                              <Typography variant="body1" color="textSecondary">
                                {dragActive === "bform"
                                  ? "Drop your file here"
                                  : "Drag & drop file or"}
                              </Typography>
                              <Button
                                component="label"
                                variant="outlined"
                                startIcon={<DriveFolderUploadOutlinedIcon />}
                                sx={{ mt: 2 }}
                              >
                                Browse
                                <VisuallyHiddenInput
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={(e) => handleFileChange(e, "bform")}
                                  required
                                />
                              </Button>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                (Supports JPG, PNG, PDF up to 5MB)
                              </Typography>
                            </Box>
                          )}
                        </FilePreviewContainer>
                      </Grid>

                      <Grid item xs={12} md={4} className="formGridItem">
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          align="center"
                        >
                          Marksheet
                        </Typography>
                        <FilePreviewContainer
                          className={
                            dragActive === "marksheet" ? "drag-active" : ""
                          }
                          onDragEnter={(e) => handleDrag(e, "marksheet")}
                          onDragOver={(e) => handleDrag(e, "marksheet")}
                          onDragLeave={(e) => handleDrag(e, "marksheet")}
                          onDrop={(e) => handleDrop(e, "marksheet")}
                        >
                          {filePreview_2 ? (
                            <>
                              {isPDF(file_2) ? (
                                <PreviewImage
                                  src="/images/pdf_icon.png"
                                  alt="Marksheet PDF"
                                />
                              ) : (
                                <PreviewImage
                                  src={filePreview_2}
                                  alt="Marksheet Preview"
                                />
                              )}
                              {file_2 && (
                                <>
                                  <FileInfo>
                                    <div className="fileName">
                                      {file_2.name}
                                    </div>
                                    <div className="fileSize">
                                      {(file_2.size / 1024).toFixed(1)} KB
                                    </div>
                                  </FileInfo>
                                  <RemoveButton
                                    variant="contained"
                                    color="error"
                                    onClick={() =>
                                      handleRemoveFile("marksheet")
                                    }
                                  >
                                    ×
                                  </RemoveButton>
                                </>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                p: 2,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{
                                  fontSize: 48,
                                  color:
                                    dragActive === "marksheet"
                                      ? "#7451f8"
                                      : "#bdbdbd",
                                  mb: 1,
                                  transition: "color 0.3s",
                                }}
                              />
                              <Typography variant="body1" color="textSecondary">
                                {dragActive === "marksheet"
                                  ? "Drop your file here"
                                  : "Drag & drop file or"}
                              </Typography>
                              <Button
                                component="label"
                                variant="outlined"
                                startIcon={<DriveFolderUploadOutlinedIcon />}
                                sx={{ mt: 2 }}
                              >
                                Browse
                                <VisuallyHiddenInput
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={(e) =>
                                    handleFileChange(e, "marksheet")
                                  }
                                  required
                                />
                              </Button>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                (Supports JPG, PNG, PDF up to 5MB)
                              </Typography>
                            </Box>
                          )}
                        </FilePreviewContainer>
                      </Grid>

                      {/* Form Fields */}
                      {studentInputs
                        .filter(
                          (input) =>
                            input.fieldName !== "status" &&
                            input.fieldName !== "roll_no"
                        )
                        .map((input) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            key={input.id}
                            className="formGridItem"
                          >
                            <div className="formInput">
                              {input.fieldName === "status" ? null : (
                                <>
                                  <label>{input.label}</label>
                                  {input.fieldName === "class_id" ? (
                                    <Select
                                      options={classoptions}
                                      name={input.fieldName}
                                      onChange={handleClassSelectChange}
                                      className="selectInput"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "46px",
                                          borderColor: "#e2e8f0",
                                          "&:hover": { borderColor: "#cbd5e0" },
                                        }),
                                      }}
                                      required
                                    />
                                  ) : input.fieldName === "batch_id" ? (
                                    <Select
                                      options={batchoptions}
                                      name={input.fieldName}
                                      onChange={handleBatchSelectChange}
                                      className="selectInput"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "46px",
                                          borderColor: "#e2e8f0",
                                          "&:hover": { borderColor: "#cbd5e0" },
                                        }),
                                      }}
                                      required
                                    />
                                  ) : input.fieldName === "group_id" ? (
                                    <Select
                                      options={groupoptions}
                                      name={input.fieldName}
                                      onChange={handleGroupSelectChange}
                                      className="selectInput"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "46px",
                                          borderColor: "#e2e8f0",
                                          "&:hover": { borderColor: "#cbd5e0" },
                                        }),
                                      }}
                                      required
                                    />
                                  ) : input.fieldName === "last_class" ? (
                                    <Select
                                      options={CheckingOptions}
                                      name={input.fieldName}
                                      onChange={handleCheckSelectChange}
                                      className="selectInput"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "46px",
                                          borderColor: "#e2e8f0",
                                          "&:hover": { borderColor: "#cbd5e0" },
                                        }),
                                      }}
                                      required
                                    />
                                  ) : input.fieldName === "last_grade" ? (
                                    <Select
                                      options={PaperOptions}
                                      name={input.fieldName}
                                      onChange={handlePaperSelectChange}
                                      className="selectInput"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "46px",
                                          borderColor: "#e2e8f0",
                                          "&:hover": { borderColor: "#cbd5e0" },
                                        }),
                                      }}
                                      required
                                    />
                                  ) : (
                                    <input
                                      type={input.type}
                                      placeholder={input.placeholder}
                                      name={input.fieldName}
                                      value={inputValues[input.fieldName] || ""}
                                      onChange={handleInputChange}
                                      required={input.fieldName !== "status"}
                                    />
                                  )}
                                </>
                              )}
                            </div>
                          </Grid>
                        ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/student")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                        // disabled={!file || !file_1 || !file_2}
                      >
                        Create Student
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default StudentNew;
